import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomToolbar from "../common/AddButton";
import  api from '../common/api';

class WorkOrderPendingVoucher extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        work_orders:[]
      }
    }

    async componentDidMount() {
      await this.getWorkOrders();
    }
   
   getWorkOrders(){
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.work_order().novouchers(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, work_orders: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, work_orders: [] })
              })
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      



  render(){
     const columns = [
     {
      name: "id",
      label: "OT",
      options: {
       filter: false,
       display: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (  
            <div><a href={"work-order/"+value} target="_blank">{value}</a></div>
          );
        }
      }
     },
     {
      name: "hansa_code",
      label: "# OT Hansa",
      options: {
       filter: false,
       display: true,
       sort: true,
      }
     },
     {
        name: "reason",
        label: "Motivo",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
     },
     {
      name: "vehicle.plate",
      label: "Patente",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
        name: "type_name",
        label: "Tipo OT",
        options: {
         filter: false,
         display: false,
         sort: true,
        }
     },
     {
      name: "budgets.0.provider.business_name",
      label: "Proveedor",
      options: {
       filter: true,
       filterType: "select",
       sort: true,
      }
     },
     {
      name: "user.name",
      label: "Operador",
      options: {
       filter: true,
       filterType: "select",
       sort: true,
      }
     },
     {
      name: "contract.name",
      label: "Contrato",
      options: {
       filter: true,
       filterType: "select",
       sort: true,
      }
     },
     {
      name: "state",
      label: "Estado",
      options: {
       filter: true,
       filterType: "dropdown",
       sort: true,
       display: true,
      }
     },
     {
      name: "total_s_iva_price",
      label: "Total",
      options: {
       filter: false,
       filterType: "textField",
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>${value}</div>
              );
        }
      }
     },
     {
      name: "updated_at",
      label: "Ult Modificación",
      options: {
       filter: false,
       filterType: "textField",
       sort: true,
       display: true
     }
    },
    {
     name: "voucher.number",
     label: "Factura",
     options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    }
   },
   {
    name: "voucher.state_name",
    label: "Estado Factura",
    options: {
     filter: true,
     filterType: "select",
     sort: true,
     display: true
   }
  }
  ];


  const options = {
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: false,
    download: false,
    rowsPerPage: 10,
      customToolbar: () => {
        return (
          <CustomToolbar url="new" />
        );
      },
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar XLS",
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
               <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de OT sin facturar"
                  data={Object.values(this.state.work_orders)}
                  columns={columns}
                  options={options}
                 />
              </MuiThemeProvider>
              </div>
            </Col>
          </Row>
         </Container>
    );
  }

}

export default WorkOrderPendingVoucher;   